/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * PHC Preferences API
 * FastAPI service for PHC user and asset preferences.
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { preferencesAxiosGenInstance } from './preferencesApiMutator';
export interface AssetGroup {
  name: string;
}

export type AssetNotificationAlertLevel = typeof AssetNotificationAlertLevel[keyof typeof AssetNotificationAlertLevel];


export const AssetNotificationAlertLevel = {
  ASSET_NOTIFICATION_ALERT_LEVEL_UNSPECIFIED: 'ASSET_NOTIFICATION_ALERT_LEVEL_UNSPECIFIED',
  ASSET_NOTIFICATION_ALERT_LEVEL_WATCH: 'ASSET_NOTIFICATION_ALERT_LEVEL_WATCH',
  ASSET_NOTIFICATION_ALERT_LEVEL_WARNING: 'ASSET_NOTIFICATION_ALERT_LEVEL_WARNING',
  ASSET_NOTIFICATION_ALERT_LEVEL_ADVISORY: 'ASSET_NOTIFICATION_ALERT_LEVEL_ADVISORY',
} as const;

export type AssetNotificationDeliveryFrequency = typeof AssetNotificationDeliveryFrequency[keyof typeof AssetNotificationDeliveryFrequency];


export const AssetNotificationDeliveryFrequency = {
  ASSET_NOTIFICATION_DELIVERY_FREQUENCY_UNSPECIFIED: 'ASSET_NOTIFICATION_DELIVERY_FREQUENCY_UNSPECIFIED',
  ASSET_NOTIFICATION_DELIVERY_FREQUENCY_INSTANT: 'ASSET_NOTIFICATION_DELIVERY_FREQUENCY_INSTANT',
  ASSET_NOTIFICATION_DELIVERY_FREQUENCY_DIGEST: 'ASSET_NOTIFICATION_DELIVERY_FREQUENCY_DIGEST',
} as const;

export type AssetNotificationType = typeof AssetNotificationType[keyof typeof AssetNotificationType];


export const AssetNotificationType = {
  ASSET_NOTIFICATION_TYPE_UNSPECIFIED: 'ASSET_NOTIFICATION_TYPE_UNSPECIFIED',
  ASSET_NOTIFICATION_TYPE_RISK_INCREASE: 'ASSET_NOTIFICATION_TYPE_RISK_INCREASE',
  ASSET_NOTIFICATION_TYPE_ALERT: 'ASSET_NOTIFICATION_TYPE_ALERT',
  ASSET_NOTIFICATION_TYPE_GUIDANCE: 'ASSET_NOTIFICATION_TYPE_GUIDANCE',
  ASSET_NOTIFICATION_TYPE_ANALYSIS: 'ASSET_NOTIFICATION_TYPE_ANALYSIS',
  ASSET_NOTIFICATION_TYPE_FORECASTED_ABSENTEEISM_INCREASE: 'ASSET_NOTIFICATION_TYPE_FORECASTED_ABSENTEEISM_INCREASE',
  ASSET_NOTIFICATION_TYPE_HISTORICAL_AVG_ABSENTEEISM_INCREASE: 'ASSET_NOTIFICATION_TYPE_HISTORICAL_AVG_ABSENTEEISM_INCREASE',
  ASSET_NOTIFICATION_TYPE_GLOBALLY_TAGGED_CONTENT: 'ASSET_NOTIFICATION_TYPE_GLOBALLY_TAGGED_CONTENT',
} as const;

export type DiseaseType = typeof DiseaseType[keyof typeof DiseaseType];


export const DiseaseType = {
  TYPE_UNSPECIFIED: 'TYPE_UNSPECIFIED',
  TYPE_COVID: 'TYPE_COVID',
  TYPE_FLU: 'TYPE_FLU',
  TYPE_RSV: 'TYPE_RSV',
  TYPE_RESP: 'TYPE_RESP',
} as const;

export type EnvironmentType = typeof EnvironmentType[keyof typeof EnvironmentType];


export const EnvironmentType = {
  TYPE_UNSPECIFIED: 'TYPE_UNSPECIFIED',
  TYPE_HEAT: 'TYPE_HEAT',
  TYPE_AIR_QUALITY: 'TYPE_AIR_QUALITY',
  TYPE_UV_INDEX: 'TYPE_UV_INDEX',
} as const;

export type AssetNotificationSettingStatus = typeof AssetNotificationSettingStatus[keyof typeof AssetNotificationSettingStatus];


export const AssetNotificationSettingStatus = {
  ASSET_NOTIFICATION_SETTING_STATUS_UNSPECIFIED: 'ASSET_NOTIFICATION_SETTING_STATUS_UNSPECIFIED',
  ASSET_NOTIFICATION_SETTING_STATUS_ENABLED: 'ASSET_NOTIFICATION_SETTING_STATUS_ENABLED',
  ASSET_NOTIFICATION_SETTING_STATUS_DISABLED: 'ASSET_NOTIFICATION_SETTING_STATUS_DISABLED',
} as const;

export type ContentType = typeof ContentType[keyof typeof ContentType];


export const ContentType = {
  CONTENT_TYPE_UNSPECIFIED: 'CONTENT_TYPE_UNSPECIFIED',
  HEADLINE: 'HEADLINE',
  GUIDANCE: 'GUIDANCE',
  ANALYSIS: 'ANALYSIS',
  CONTENT_TYPE_ALERT: 'CONTENT_TYPE_ALERT',
  CONTENT_TYPE_CRITICAL_THREAT: 'CONTENT_TYPE_CRITICAL_THREAT',
} as const;

export interface AssetNotificationSettingSchema {
  notification_type: AssetNotificationType;
  asset_id?: string | null;
  disease_type?: DiseaseType | null;
  environment_type?: EnvironmentType | null;
  status: AssetNotificationSettingStatus;
  alert_level?: AssetNotificationAlertLevel | null;
  delivery_frequency?: AssetNotificationDeliveryFrequency | null;
  content_type?: ContentType | null;
  forecast_range?: number | null;
}

export type IndustryType = typeof IndustryType[keyof typeof IndustryType];


export const IndustryType = {
  INDUSTRY_TYPE_UNSPECIFIED: 'INDUSTRY_TYPE_UNSPECIFIED',
  INDUSTRY_TYPE_RETAIL: 'INDUSTRY_TYPE_RETAIL',
  INDUSTRY_TYPE_FINANCE: 'INDUSTRY_TYPE_FINANCE',
  INDUSTRY_TYPE_PROFESSIONAL_SERVICES: 'INDUSTRY_TYPE_PROFESSIONAL_SERVICES',
  INDUSTRY_TYPE_INFORMATION: 'INDUSTRY_TYPE_INFORMATION',
  INDUSTRY_TYPE_TRANSPORTATION_AND_WAREHOUSING: 'INDUSTRY_TYPE_TRANSPORTATION_AND_WAREHOUSING',
  INDUSTRY_TYPE_BASELINE: 'INDUSTRY_TYPE_BASELINE',
} as const;

export type PlaceType = typeof PlaceType[keyof typeof PlaceType];


export const PlaceType = {
  PLACE_TYPE_UNSPECIFIED: 'PLACE_TYPE_UNSPECIFIED',
  PLACE_TYPE_COUNTRY: 'PLACE_TYPE_COUNTRY',
  PLACE_TYPE_REGION: 'PLACE_TYPE_REGION',
  PLACE_TYPE_POSTCODE: 'PLACE_TYPE_POSTCODE',
  PLACE_TYPE_DISTRICT: 'PLACE_TYPE_DISTRICT',
  PLACE_TYPE_PLACE: 'PLACE_TYPE_PLACE',
  PLACE_TYPE_LOCALITY: 'PLACE_TYPE_LOCALITY',
  PLACE_TYPE_NEIGHBORHOOD: 'PLACE_TYPE_NEIGHBORHOOD',
  PLACE_TYPE_ADDRESS: 'PLACE_TYPE_ADDRESS',
  PLACE_TYPE_POI: 'PLACE_TYPE_POI',
} as const;

export interface MapboxLocationSchema {
  id?: string | null;
  place_name?: string | null;
  place_type?: PlaceType | null;
  text?: string | null;
  country?: string | null;
  region?: string | null;
  postcode?: string | null;
  district?: string | null;
  place?: string | null;
  locality?: string | null;
  neighborhood?: string | null;
  address?: string | null;
  poi?: string | null;
}

export interface GeotagSchema {
  location_id: string;
  wkt_centroid?: string | null;
  mapbox_location?: MapboxLocationSchema | null;
}

export interface BaseEventSchema {
  geotags: GeotagSchema[];
}

export type AssetType = typeof AssetType[keyof typeof AssetType];


export const AssetType = {
  ASSET_TYPE_UNSPECIFIED: 'ASSET_TYPE_UNSPECIFIED',
  OFFICE: 'OFFICE',
  WAREHOUSE: 'WAREHOUSE',
  DATA_CENTER: 'DATA_CENTER',
  RETAIL_STORE: 'RETAIL_STORE',
  MANUFACTURING_PLANT: 'MANUFACTURING_PLANT',
  RESTAURANT_CAFE: 'RESTAURANT_CAFE',
  HOTEL: 'HOTEL',
  FITNESS_CENTER: 'FITNESS_CENTER',
  SPA_SALON: 'SPA_SALON',
  MOVIE_THEATER: 'MOVIE_THEATER',
  MEDICAL_CENTER: 'MEDICAL_CENTER',
  DISTRIBUTION_CENTER: 'DISTRIBUTION_CENTER',
  CALL_CENTER: 'CALL_CENTER',
  FINANCIAL_INSTITUTION: 'FINANCIAL_INSTITUTION',
  AIRPORT: 'AIRPORT',
  AGRIBUSINESS: 'AGRIBUSINESS',
  INDOOR_EVENT_VENUE: 'INDOOR_EVENT_VENUE',
  OUTDOOR_EVENT_VENUE: 'OUTDOOR_EVENT_VENUE',
  BAR_NIGHTCLUB: 'BAR_NIGHTCLUB',
  COMMERCIAL_KITCHEN: 'COMMERCIAL_KITCHEN',
  EDUCATIONAL_INSTITUTION: 'EDUCATIONAL_INSTITUTION',
  COMMAND_CENTER: 'COMMAND_CENTER',
  ASSET_TYPE_OTHER: 'ASSET_TYPE_OTHER',
} as const;

export interface AssetPayload {
  asset_id?: string | null;
  name?: string | null;
  notes?: string | null;
  threat_radius?: number | null;
  industry?: IndustryType | null;
  base_event?: BaseEventSchema | null;
  asset_groups?: AssetGroup[];
  asset_types?: AssetType[];
  notification_settings?: AssetNotificationSettingSchema[];
}

export interface CreateAssetRequest {
  asset: AssetPayload;
}

export interface CreateAssetsRequest {
  assets: AssetPayload[];
}

export interface CreateOrgAndUserRequest {
  organization_name?: string | null;
  organization_auth0_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email_address?: string | null;
  auth0_id?: string | null;
}

export interface CreateOrganizationRequest {
  organization_name?: string | null;
  auth0_id?: string | null;
}

export type ThreatNotificationSource = typeof ThreatNotificationSource[keyof typeof ThreatNotificationSource];


export const ThreatNotificationSource = {
  THREAT_NOTIFICATION_SOURCE_WW_ANOMALY: 'THREAT_NOTIFICATION_SOURCE_WW_ANOMALY',
  THREAT_NOTIFICATION_SOURCE_UNDEFINED: 'THREAT_NOTIFICATION_SOURCE_UNDEFINED',
} as const;

export type ThreatTrend = typeof ThreatTrend[keyof typeof ThreatTrend];


export const ThreatTrend = {
  TREND_UNSPECIFIED: 'TREND_UNSPECIFIED',
  TREND_INCREASING_RAPIDLY: 'TREND_INCREASING_RAPIDLY',
  TREND_INCREASING: 'TREND_INCREASING',
  TREND_PERSISTENT: 'TREND_PERSISTENT',
  TREND_DECREASING: 'TREND_DECREASING',
  TREND_DECREASING_RAPIDLY: 'TREND_DECREASING_RAPIDLY',
} as const;

export type ThreatSeverity = typeof ThreatSeverity[keyof typeof ThreatSeverity];


export const ThreatSeverity = {
  SEVERITY_UNSPECIFIED: 'SEVERITY_UNSPECIFIED',
  SEVERITY_LOW: 'SEVERITY_LOW',
  SEVERITY_MODERATE: 'SEVERITY_MODERATE',
  SEVERITY_HIGH: 'SEVERITY_HIGH',
  SEVERITY_SEVERE: 'SEVERITY_SEVERE',
} as const;

export interface CreateThreatNotificationRequest {
  source: ThreatNotificationSource;
  title: string;
  description: string;
  pathogen: string;
  location: string;
  site?: string | null;
  trend?: ThreatTrend | null;
  severity: ThreatSeverity;
  detected_at: string;
}

export interface CreateUserRequest {
  organization_id: string;
  first_name?: string | null;
  last_name?: string | null;
  email_address?: string | null;
  auth0_id?: string | null;
}

export interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

/**
 * Response model for /health.
 */
export interface HealthResponse {
  status?: string;
  service?: string;
  version?: string;
}

export interface PaginationSchema {
  from: number;
  size: number;
}

export interface ListUsersAssetsRequest {
  pagination?: PaginationSchema | null;
  user_ids?: string[];
  notification_status?: AssetNotificationSettingStatus | null;
}

export interface OrganizationResponse {
  organization_id: string;
  organization_name: string | null;
  auth0_id: string | null;
}

export interface UserResponse {
  pharos_user_id: string;
  organization_id: string;
  first_name: string | null;
  last_name: string | null;
  email_address: string | null;
  auth0_id: string | null;
}

export interface OrgAndUserResponse {
  organization: OrganizationResponse;
  user: UserResponse;
}

export type PharosUserThreatNotificationStatusEnum = typeof PharosUserThreatNotificationStatusEnum[keyof typeof PharosUserThreatNotificationStatusEnum];


export const PharosUserThreatNotificationStatusEnum = {
  USER_THREAT_NOTIFICATION_STATUS_READ: 'USER_THREAT_NOTIFICATION_STATUS_READ',
  USER_THREAT_NOTIFICATION_STATUS_UNREAD: 'USER_THREAT_NOTIFICATION_STATUS_UNREAD',
  USER_THREAT_NOTIFICATION_STATUS_DISMISSED: 'USER_THREAT_NOTIFICATION_STATUS_DISMISSED',
  USER_THREAT_NOTIFICATION_STATUS_FAILED: 'USER_THREAT_NOTIFICATION_STATUS_FAILED',
} as const;

export interface TOSAgreementSchema {
  tos_doc_name: string;
  tos_created_at?: string | null;
  tos_signed_at?: string | null;
}

export interface ThreatNotificationCreateResponse {
  threat_notification_id: string;
  source: ThreatNotificationSource;
  title: string;
  description: string;
  pathogen: string;
  location: string;
  site: string | null;
  trend: ThreatTrend | null;
  severity: ThreatSeverity;
  detected_at: string;
  created_at: string;
}

export interface ThreatNotificationDetailResponse {
  threat_notification_id: string;
  source: ThreatNotificationSource;
  title: string;
  description: string;
  pathogen: string;
  location: string;
  site: string | null;
  trend: ThreatTrend | null;
  severity: ThreatSeverity;
  detected_at: string;
  created_at: string;
}

export interface ThreatNotificationListItemResponse {
  threat_notification_id: string;
  source: ThreatNotificationSource;
  title: string;
  description: string;
  pathogen: string;
  location: string;
  site: string | null;
  trend: ThreatTrend | null;
  severity: ThreatSeverity;
  detected_at: string;
  created_at: string;
}

export interface UpdateAssetRequest {
  asset: AssetPayload;
}

export interface UpdateAssetsRequest {
  assets: AssetPayload[];
}

export interface UpdateNotificationSettingsRequest {
  asset_notification_settings: AssetNotificationSettingSchema[];
}

export interface UpdatePharosUserStatusRequest {
  user_id: string;
  is_active: boolean;
}

export interface UpdatePharosUserTOSRequest {
  tos_agreement: TOSAgreementSchema;
}

export interface UserTrialUserSchema {
  user_id: string;
}

export interface UserTrialSchema {
  user_id?: string | null;
  user?: UserTrialUserSchema | null;
  is_trial_user: boolean;
  trial_started_at?: string | null;
  trial_ended_at?: string | null;
}

export interface UpdatePharosUserTrialRequest {
  user_trial: UserTrialSchema;
}

export interface UpdateThreatNotificationStatusRequest {
  status: PharosUserThreatNotificationStatusEnum;
}

export interface UserThreatNotificationStatusListResponse {
  threat_notification_id: string;
  pharos_user_id: string;
  status: PharosUserThreatNotificationStatusEnum;
  created_at: string;
  updated_at: string;
  notification: ThreatNotificationListItemResponse;
}

export interface UserThreatNotificationStatusMutationResponse {
  threat_notification_id: string;
  pharos_user_id: string;
  status: PharosUserThreatNotificationStatusEnum;
  created_at: string;
  updated_at: string;
}

export type IndexGet200 = {[key: string]: string};

export type ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams = {
pharos_user_id?: string | null;
threat_notification_id?: string | null;
};

export type GetAssetAssetAssetIdGetParams = {
exclude_notifications?: boolean;
exclude_groups?: boolean;
};

export type GetAssetAssetAssetIdGet200 = { [key: string]: unknown };

export type RemoveAssetAssetAssetIdDelete200 = { [key: string]: unknown };

export type ListAssetsAssetsGetParams = {
from?: number;
size?: number;
exclude_notifications?: boolean;
exclude_groups?: boolean;
};

export type ListAssetsAssetsGet200 = { [key: string]: unknown };

export type CreateAssetsAssetsPost200 = { [key: string]: unknown };

export type UpdateAssetsAssetsPut200 = { [key: string]: unknown };

export type ListUsersAssetsUsersAssetsPost200 = { [key: string]: unknown };

export type UpdateAssetAssetPut200 = { [key: string]: unknown };

export type CreateAssetAssetPost200 = { [key: string]: unknown };

export type UpdateNotificationSettingsNotificationSettingsPut200 = { [key: string]: unknown };

export type ListAssetGroupsAssetGroupsGetParams = {
from?: number;
size?: number;
};

export type ListAssetGroupsAssetGroupsGet200 = { [key: string]: unknown };

export type RemoveAssetGroupAssetGroupsAssetGroupIdDelete200 = { [key: string]: unknown };

export type GetPharosUserTosPharosUserTOSGet200 = { [key: string]: unknown };

export type UpdatePharosUserTosRoutePharosUserTOSPut200 = { [key: string]: unknown };

export type UpdatePharosUserTrialRoutePharosUserTrialPut200 = { [key: string]: unknown };

export type UpdatePharosUserStatusRoutePharosUserStatusPut200 = { [key: string]: unknown };

export type ListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet200 = { [key: string]: unknown };

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Basic route to indicate that the API is responding.
 * @summary API index
 */
export const indexGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<IndexGet200>(
      {url: `/`, method: 'GET', signal
    },
      options);
    }




export const getIndexGetQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getIndexGetQueryOptions = <TData = Awaited<ReturnType<typeof indexGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndexGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof indexGet>>> = ({ signal }) => indexGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IndexGetQueryResult = NonNullable<Awaited<ReturnType<typeof indexGet>>>
export type IndexGetQueryError = unknown


export function useIndexGet<TData = Awaited<ReturnType<typeof indexGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof indexGet>>,
          TError,
          Awaited<ReturnType<typeof indexGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndexGet<TData = Awaited<ReturnType<typeof indexGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof indexGet>>,
          TError,
          Awaited<ReturnType<typeof indexGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndexGet<TData = Awaited<ReturnType<typeof indexGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary API index
 */

export function useIndexGet<TData = Awaited<ReturnType<typeof indexGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indexGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIndexGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Lightweight health endpoint for orchestration probes.
 * @summary Container health endpoint
 */
export const healthHealthGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<HealthResponse>(
      {url: `/health`, method: 'GET', signal
    },
      options);
    }




export const getHealthHealthGetQueryKey = () => {
    return [
    `/health`
    ] as const;
    }


export const getHealthHealthGetQueryOptions = <TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthHealthGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthHealthGet>>> = ({ signal }) => healthHealthGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthHealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthHealthGet>>>
export type HealthHealthGetQueryError = unknown


export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Container health endpoint
 */

export function useHealthHealthGet<TData = Awaited<ReturnType<typeof healthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthHealthGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthHealthGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List Users
 */
export const listUsersListUsersGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UserResponse[]>(
      {url: `/listUsers`, method: 'GET', signal
    },
      options);
    }




export const getListUsersListUsersGetQueryKey = () => {
    return [
    `/listUsers`
    ] as const;
    }


export const getListUsersListUsersGetQueryOptions = <TData = Awaited<ReturnType<typeof listUsersListUsersGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersListUsersGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersListUsersGet>>> = ({ signal }) => listUsersListUsersGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersListUsersGetQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersListUsersGet>>>
export type ListUsersListUsersGetQueryError = unknown


export function useListUsersListUsersGet<TData = Awaited<ReturnType<typeof listUsersListUsersGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersListUsersGet>>,
          TError,
          Awaited<ReturnType<typeof listUsersListUsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersListUsersGet<TData = Awaited<ReturnType<typeof listUsersListUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersListUsersGet>>,
          TError,
          Awaited<ReturnType<typeof listUsersListUsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersListUsersGet<TData = Awaited<ReturnType<typeof listUsersListUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Users
 */

export function useListUsersListUsersGet<TData = Awaited<ReturnType<typeof listUsersListUsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersListUsersGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersListUsersGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create User
 */
export const createUserCreateUserPost = (
    createUserRequest: CreateUserRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UserResponse>(
      {url: `/createUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      options);
    }



export const getCreateUserCreateUserPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserCreateUserPost>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserCreateUserPost>>, TError,{data: CreateUserRequest}, TContext> => {

const mutationKey = ['createUserCreateUserPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserCreateUserPost>>, {data: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUserCreateUserPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserCreateUserPostMutationResult = NonNullable<Awaited<ReturnType<typeof createUserCreateUserPost>>>
    export type CreateUserCreateUserPostMutationBody = CreateUserRequest
    export type CreateUserCreateUserPostMutationError = HTTPValidationError

    /**
 * @summary Create User
 */
export const useCreateUserCreateUserPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserCreateUserPost>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserCreateUserPost>>,
        TError,
        {data: CreateUserRequest},
        TContext
      > => {
      return useMutation(getCreateUserCreateUserPostMutationOptions(options), queryClient);
    }

/**
 * @summary Create Org
 */
export const createOrgCreateOrgPost = (
    createOrganizationRequest: CreateOrganizationRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<OrganizationResponse>(
      {url: `/createOrg`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationRequest, signal
    },
      options);
    }



export const getCreateOrgCreateOrgPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgCreateOrgPost>>, TError,{data: CreateOrganizationRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgCreateOrgPost>>, TError,{data: CreateOrganizationRequest}, TContext> => {

const mutationKey = ['createOrgCreateOrgPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgCreateOrgPost>>, {data: CreateOrganizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrgCreateOrgPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgCreateOrgPostMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgCreateOrgPost>>>
    export type CreateOrgCreateOrgPostMutationBody = CreateOrganizationRequest
    export type CreateOrgCreateOrgPostMutationError = HTTPValidationError

    /**
 * @summary Create Org
 */
export const useCreateOrgCreateOrgPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgCreateOrgPost>>, TError,{data: CreateOrganizationRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrgCreateOrgPost>>,
        TError,
        {data: CreateOrganizationRequest},
        TContext
      > => {
      return useMutation(getCreateOrgCreateOrgPostMutationOptions(options), queryClient);
    }

/**
 * @summary Create Org And User
 */
export const createOrgAndUserCreateOrgAndUserPost = (
    createOrgAndUserRequest: CreateOrgAndUserRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<OrgAndUserResponse>(
      {url: `/createOrgAndUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrgAndUserRequest, signal
    },
      options);
    }



export const getCreateOrgAndUserCreateOrgAndUserPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>, TError,{data: CreateOrgAndUserRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>, TError,{data: CreateOrgAndUserRequest}, TContext> => {

const mutationKey = ['createOrgAndUserCreateOrgAndUserPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>, {data: CreateOrgAndUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrgAndUserCreateOrgAndUserPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgAndUserCreateOrgAndUserPostMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>>
    export type CreateOrgAndUserCreateOrgAndUserPostMutationBody = CreateOrgAndUserRequest
    export type CreateOrgAndUserCreateOrgAndUserPostMutationError = HTTPValidationError

    /**
 * @summary Create Org And User
 */
export const useCreateOrgAndUserCreateOrgAndUserPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>, TError,{data: CreateOrgAndUserRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrgAndUserCreateOrgAndUserPost>>,
        TError,
        {data: CreateOrgAndUserRequest},
        TContext
      > => {
      return useMutation(getCreateOrgAndUserCreateOrgAndUserPostMutationOptions(options), queryClient);
    }

/**
 * @summary List Threat Notifications
 */
export const listThreatNotificationsThreatNotificationsGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ThreatNotificationListItemResponse[]>(
      {url: `/threatNotifications`, method: 'GET', signal
    },
      options);
    }




export const getListThreatNotificationsThreatNotificationsGetQueryKey = () => {
    return [
    `/threatNotifications`
    ] as const;
    }


export const getListThreatNotificationsThreatNotificationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListThreatNotificationsThreatNotificationsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>> = ({ signal }) => listThreatNotificationsThreatNotificationsGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListThreatNotificationsThreatNotificationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>>
export type ListThreatNotificationsThreatNotificationsGetQueryError = unknown


export function useListThreatNotificationsThreatNotificationsGet<TData = Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListThreatNotificationsThreatNotificationsGet<TData = Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>,
          TError,
          Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListThreatNotificationsThreatNotificationsGet<TData = Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Threat Notifications
 */

export function useListThreatNotificationsThreatNotificationsGet<TData = Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreatNotificationsThreatNotificationsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListThreatNotificationsThreatNotificationsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Threat Notification
 */
export const createThreatNotificationThreatNotificationsPost = (
    createThreatNotificationRequest: CreateThreatNotificationRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ThreatNotificationCreateResponse>(
      {url: `/threatNotifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createThreatNotificationRequest, signal
    },
      options);
    }



export const getCreateThreatNotificationThreatNotificationsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>, TError,{data: CreateThreatNotificationRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>, TError,{data: CreateThreatNotificationRequest}, TContext> => {

const mutationKey = ['createThreatNotificationThreatNotificationsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>, {data: CreateThreatNotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createThreatNotificationThreatNotificationsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateThreatNotificationThreatNotificationsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>>
    export type CreateThreatNotificationThreatNotificationsPostMutationBody = CreateThreatNotificationRequest
    export type CreateThreatNotificationThreatNotificationsPostMutationError = HTTPValidationError

    /**
 * @summary Create Threat Notification
 */
export const useCreateThreatNotificationThreatNotificationsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>, TError,{data: CreateThreatNotificationRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createThreatNotificationThreatNotificationsPost>>,
        TError,
        {data: CreateThreatNotificationRequest},
        TContext
      > => {
      return useMutation(getCreateThreatNotificationThreatNotificationsPostMutationOptions(options), queryClient);
    }

/**
 * @summary Get Threat Notification
 */
export const getThreatNotificationThreatNotificationsThreatNotificationIdGet = (
    threatNotificationId: string,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ThreatNotificationDetailResponse>(
      {url: `/threatNotifications/${threatNotificationId}`, method: 'GET', signal
    },
      options);
    }




export const getGetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryKey = (threatNotificationId: string,) => {
    return [
    `/threatNotifications/${threatNotificationId}`
    ] as const;
    }


export const getGetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError = HTTPValidationError>(threatNotificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryKey(threatNotificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>> = ({ signal }) => getThreatNotificationThreatNotificationsThreatNotificationIdGet(threatNotificationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: threatNotificationId !== null && threatNotificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>>
export type GetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryError = HTTPValidationError


export function useGetThreatNotificationThreatNotificationsThreatNotificationIdGet<TData = Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError = HTTPValidationError>(
 threatNotificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>,
          TError,
          Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreatNotificationThreatNotificationsThreatNotificationIdGet<TData = Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError = HTTPValidationError>(
 threatNotificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>,
          TError,
          Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetThreatNotificationThreatNotificationsThreatNotificationIdGet<TData = Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError = HTTPValidationError>(
 threatNotificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Threat Notification
 */

export function useGetThreatNotificationThreatNotificationsThreatNotificationIdGet<TData = Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError = HTTPValidationError>(
 threatNotificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getThreatNotificationThreatNotificationsThreatNotificationIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetThreatNotificationThreatNotificationsThreatNotificationIdGetQueryOptions(threatNotificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary List User Threat Notification Statuses
 */
export const listUserThreatNotificationStatusesUserThreatNotificationStatusesGet = (
    params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UserThreatNotificationStatusListResponse[]>(
      {url: `/userThreatNotificationStatuses`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryKey = (params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams,) => {
    return [
    `/userThreatNotificationStatuses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryOptions = <TData = Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError = HTTPValidationError>(params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>> = ({ signal }) => listUserThreatNotificationStatusesUserThreatNotificationStatusesGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>>
export type ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryError = HTTPValidationError


export function useListUserThreatNotificationStatusesUserThreatNotificationStatusesGet<TData = Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError = HTTPValidationError>(
 params: undefined |  ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>,
          TError,
          Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserThreatNotificationStatusesUserThreatNotificationStatusesGet<TData = Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError = HTTPValidationError>(
 params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>,
          TError,
          Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserThreatNotificationStatusesUserThreatNotificationStatusesGet<TData = Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError = HTTPValidationError>(
 params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List User Threat Notification Statuses
 */

export function useListUserThreatNotificationStatusesUserThreatNotificationStatusesGet<TData = Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError = HTTPValidationError>(
 params?: ListUserThreatNotificationStatusesUserThreatNotificationStatusesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserThreatNotificationStatusesUserThreatNotificationStatusesGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserThreatNotificationStatusesUserThreatNotificationStatusesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Threat Notification Status
 */
export const updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut = (
    pharosUserId: string,
    threatNotificationId: string,
    updateThreatNotificationStatusRequest: UpdateThreatNotificationStatusRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UserThreatNotificationStatusMutationResponse>(
      {url: `/userThreatNotificationStatus/${pharosUserId}/${threatNotificationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateThreatNotificationStatusRequest, signal
    },
      options);
    }



export const getUpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>, TError,{pharosUserId: string;threatNotificationId: string;data: UpdateThreatNotificationStatusRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>, TError,{pharosUserId: string;threatNotificationId: string;data: UpdateThreatNotificationStatusRequest}, TContext> => {

const mutationKey = ['updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>, {pharosUserId: string;threatNotificationId: string;data: UpdateThreatNotificationStatusRequest}> = (props) => {
          const {pharosUserId,threatNotificationId,data} = props ?? {};

          return  updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut(pharosUserId,threatNotificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>>
    export type UpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPutMutationBody = UpdateThreatNotificationStatusRequest
    export type UpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPutMutationError = HTTPValidationError

    /**
 * @summary Update Threat Notification Status
 */
export const useUpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>, TError,{pharosUserId: string;threatNotificationId: string;data: UpdateThreatNotificationStatusRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPut>>,
        TError,
        {pharosUserId: string;threatNotificationId: string;data: UpdateThreatNotificationStatusRequest},
        TContext
      > => {
      return useMutation(getUpdateThreatNotificationStatusUserThreatNotificationStatusPharosUserIdThreatNotificationIdPutMutationOptions(options), queryClient);
    }

/**
 * @summary Get Asset
 */
export const getAssetAssetAssetIdGet = (
    assetId: string,
    params?: GetAssetAssetAssetIdGetParams,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<GetAssetAssetAssetIdGet200>(
      {url: `/asset/${assetId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAssetAssetAssetIdGetQueryKey = (assetId: string,
    params?: GetAssetAssetAssetIdGetParams,) => {
    return [
    `/asset/${assetId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAssetAssetAssetIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError = HTTPValidationError>(assetId: string,
    params?: GetAssetAssetAssetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetAssetAssetIdGetQueryKey(assetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>> = ({ signal }) => getAssetAssetAssetIdGet(assetId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: assetId !== null && assetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetAssetAssetIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>>
export type GetAssetAssetAssetIdGetQueryError = HTTPValidationError


export function useGetAssetAssetAssetIdGet<TData = Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError = HTTPValidationError>(
 assetId: string,
    params: undefined |  GetAssetAssetAssetIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAssetAssetIdGet<TData = Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError = HTTPValidationError>(
 assetId: string,
    params?: GetAssetAssetAssetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAssetAssetIdGet<TData = Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError = HTTPValidationError>(
 assetId: string,
    params?: GetAssetAssetAssetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Asset
 */

export function useGetAssetAssetAssetIdGet<TData = Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError = HTTPValidationError>(
 assetId: string,
    params?: GetAssetAssetAssetIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAssetAssetIdGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetAssetAssetIdGetQueryOptions(assetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Remove Asset
 */
export const removeAssetAssetAssetIdDelete = (
    assetId: string,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<RemoveAssetAssetAssetIdDelete200>(
      {url: `/asset/${assetId}`, method: 'DELETE', signal
    },
      options);
    }



export const getRemoveAssetAssetAssetIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>, TError,{assetId: string}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>, TError,{assetId: string}, TContext> => {

const mutationKey = ['removeAssetAssetAssetIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>, {assetId: string}> = (props) => {
          const {assetId} = props ?? {};

          return  removeAssetAssetAssetIdDelete(assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAssetAssetAssetIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>>

    export type RemoveAssetAssetAssetIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Remove Asset
 */
export const useRemoveAssetAssetAssetIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>, TError,{assetId: string}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAssetAssetAssetIdDelete>>,
        TError,
        {assetId: string},
        TContext
      > => {
      return useMutation(getRemoveAssetAssetAssetIdDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary List Assets
 */
export const listAssetsAssetsGet = (
    params?: ListAssetsAssetsGetParams,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ListAssetsAssetsGet200>(
      {url: `/assets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAssetsAssetsGetQueryKey = (params?: ListAssetsAssetsGetParams,) => {
    return [
    `/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssetsAssetsGetQueryOptions = <TData = Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError = HTTPValidationError>(params?: ListAssetsAssetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetsAssetsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetsAssetsGet>>> = ({ signal }) => listAssetsAssetsGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetsAssetsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetsAssetsGet>>>
export type ListAssetsAssetsGetQueryError = HTTPValidationError


export function useListAssetsAssetsGet<TData = Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListAssetsAssetsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetsAssetsGet>>,
          TError,
          Awaited<ReturnType<typeof listAssetsAssetsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetsAssetsGet<TData = Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError = HTTPValidationError>(
 params?: ListAssetsAssetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetsAssetsGet>>,
          TError,
          Awaited<ReturnType<typeof listAssetsAssetsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetsAssetsGet<TData = Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError = HTTPValidationError>(
 params?: ListAssetsAssetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assets
 */

export function useListAssetsAssetsGet<TData = Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError = HTTPValidationError>(
 params?: ListAssetsAssetsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetsAssetsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssetsAssetsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Assets
 */
export const createAssetsAssetsPost = (
    createAssetsRequest: CreateAssetsRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<CreateAssetsAssetsPost200>(
      {url: `/assets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssetsRequest, signal
    },
      options);
    }



export const getCreateAssetsAssetsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssetsAssetsPost>>, TError,{data: CreateAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssetsAssetsPost>>, TError,{data: CreateAssetsRequest}, TContext> => {

const mutationKey = ['createAssetsAssetsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssetsAssetsPost>>, {data: CreateAssetsRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAssetsAssetsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssetsAssetsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createAssetsAssetsPost>>>
    export type CreateAssetsAssetsPostMutationBody = CreateAssetsRequest
    export type CreateAssetsAssetsPostMutationError = HTTPValidationError

    /**
 * @summary Create Assets
 */
export const useCreateAssetsAssetsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssetsAssetsPost>>, TError,{data: CreateAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssetsAssetsPost>>,
        TError,
        {data: CreateAssetsRequest},
        TContext
      > => {
      return useMutation(getCreateAssetsAssetsPostMutationOptions(options), queryClient);
    }

/**
 * @summary Update Assets
 */
export const updateAssetsAssetsPut = (
    updateAssetsRequest: UpdateAssetsRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdateAssetsAssetsPut200>(
      {url: `/assets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAssetsRequest, signal
    },
      options);
    }



export const getUpdateAssetsAssetsPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetsAssetsPut>>, TError,{data: UpdateAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssetsAssetsPut>>, TError,{data: UpdateAssetsRequest}, TContext> => {

const mutationKey = ['updateAssetsAssetsPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssetsAssetsPut>>, {data: UpdateAssetsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAssetsAssetsPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssetsAssetsPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssetsAssetsPut>>>
    export type UpdateAssetsAssetsPutMutationBody = UpdateAssetsRequest
    export type UpdateAssetsAssetsPutMutationError = HTTPValidationError

    /**
 * @summary Update Assets
 */
export const useUpdateAssetsAssetsPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetsAssetsPut>>, TError,{data: UpdateAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssetsAssetsPut>>,
        TError,
        {data: UpdateAssetsRequest},
        TContext
      > => {
      return useMutation(getUpdateAssetsAssetsPutMutationOptions(options), queryClient);
    }

/**
 * @summary List Users Assets
 */
export const listUsersAssetsUsersAssetsPost = (
    listUsersAssetsRequest: ListUsersAssetsRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ListUsersAssetsUsersAssetsPost200>(
      {url: `/usersAssets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listUsersAssetsRequest, signal
    },
      options);
    }



export const getListUsersAssetsUsersAssetsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>, TError,{data: ListUsersAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>, TError,{data: ListUsersAssetsRequest}, TContext> => {

const mutationKey = ['listUsersAssetsUsersAssetsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>, {data: ListUsersAssetsRequest}> = (props) => {
          const {data} = props ?? {};

          return  listUsersAssetsUsersAssetsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListUsersAssetsUsersAssetsPostMutationResult = NonNullable<Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>>
    export type ListUsersAssetsUsersAssetsPostMutationBody = ListUsersAssetsRequest
    export type ListUsersAssetsUsersAssetsPostMutationError = HTTPValidationError

    /**
 * @summary List Users Assets
 */
export const useListUsersAssetsUsersAssetsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>, TError,{data: ListUsersAssetsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listUsersAssetsUsersAssetsPost>>,
        TError,
        {data: ListUsersAssetsRequest},
        TContext
      > => {
      return useMutation(getListUsersAssetsUsersAssetsPostMutationOptions(options), queryClient);
    }

/**
 * @summary Update Asset
 */
export const updateAssetAssetPut = (
    updateAssetRequest: UpdateAssetRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdateAssetAssetPut200>(
      {url: `/asset`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAssetRequest, signal
    },
      options);
    }



export const getUpdateAssetAssetPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetAssetPut>>, TError,{data: UpdateAssetRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssetAssetPut>>, TError,{data: UpdateAssetRequest}, TContext> => {

const mutationKey = ['updateAssetAssetPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssetAssetPut>>, {data: UpdateAssetRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAssetAssetPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssetAssetPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssetAssetPut>>>
    export type UpdateAssetAssetPutMutationBody = UpdateAssetRequest
    export type UpdateAssetAssetPutMutationError = HTTPValidationError

    /**
 * @summary Update Asset
 */
export const useUpdateAssetAssetPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetAssetPut>>, TError,{data: UpdateAssetRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssetAssetPut>>,
        TError,
        {data: UpdateAssetRequest},
        TContext
      > => {
      return useMutation(getUpdateAssetAssetPutMutationOptions(options), queryClient);
    }

/**
 * @summary Create Asset
 */
export const createAssetAssetPost = (
    createAssetRequest: CreateAssetRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<CreateAssetAssetPost200>(
      {url: `/asset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssetRequest, signal
    },
      options);
    }



export const getCreateAssetAssetPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssetAssetPost>>, TError,{data: CreateAssetRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssetAssetPost>>, TError,{data: CreateAssetRequest}, TContext> => {

const mutationKey = ['createAssetAssetPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssetAssetPost>>, {data: CreateAssetRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAssetAssetPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssetAssetPostMutationResult = NonNullable<Awaited<ReturnType<typeof createAssetAssetPost>>>
    export type CreateAssetAssetPostMutationBody = CreateAssetRequest
    export type CreateAssetAssetPostMutationError = HTTPValidationError

    /**
 * @summary Create Asset
 */
export const useCreateAssetAssetPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssetAssetPost>>, TError,{data: CreateAssetRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssetAssetPost>>,
        TError,
        {data: CreateAssetRequest},
        TContext
      > => {
      return useMutation(getCreateAssetAssetPostMutationOptions(options), queryClient);
    }

/**
 * @summary Update Notification Settings
 */
export const updateNotificationSettingsNotificationSettingsPut = (
    updateNotificationSettingsRequest: UpdateNotificationSettingsRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdateNotificationSettingsNotificationSettingsPut200>(
      {url: `/notificationSettings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateNotificationSettingsRequest, signal
    },
      options);
    }



export const getUpdateNotificationSettingsNotificationSettingsPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>, TError,{data: UpdateNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>, TError,{data: UpdateNotificationSettingsRequest}, TContext> => {

const mutationKey = ['updateNotificationSettingsNotificationSettingsPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>, {data: UpdateNotificationSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationSettingsNotificationSettingsPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationSettingsNotificationSettingsPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>>
    export type UpdateNotificationSettingsNotificationSettingsPutMutationBody = UpdateNotificationSettingsRequest
    export type UpdateNotificationSettingsNotificationSettingsPutMutationError = HTTPValidationError

    /**
 * @summary Update Notification Settings
 */
export const useUpdateNotificationSettingsNotificationSettingsPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>, TError,{data: UpdateNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationSettingsNotificationSettingsPut>>,
        TError,
        {data: UpdateNotificationSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateNotificationSettingsNotificationSettingsPutMutationOptions(options), queryClient);
    }

/**
 * @summary List Asset Groups
 */
export const listAssetGroupsAssetGroupsGet = (
    params?: ListAssetGroupsAssetGroupsGetParams,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ListAssetGroupsAssetGroupsGet200>(
      {url: `/assetGroups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAssetGroupsAssetGroupsGetQueryKey = (params?: ListAssetGroupsAssetGroupsGetParams,) => {
    return [
    `/assetGroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssetGroupsAssetGroupsGetQueryOptions = <TData = Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError = HTTPValidationError>(params?: ListAssetGroupsAssetGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetGroupsAssetGroupsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>> = ({ signal }) => listAssetGroupsAssetGroupsGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetGroupsAssetGroupsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>>
export type ListAssetGroupsAssetGroupsGetQueryError = HTTPValidationError


export function useListAssetGroupsAssetGroupsGet<TData = Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListAssetGroupsAssetGroupsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>,
          TError,
          Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetGroupsAssetGroupsGet<TData = Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError = HTTPValidationError>(
 params?: ListAssetGroupsAssetGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>,
          TError,
          Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetGroupsAssetGroupsGet<TData = Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError = HTTPValidationError>(
 params?: ListAssetGroupsAssetGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Asset Groups
 */

export function useListAssetGroupsAssetGroupsGet<TData = Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError = HTTPValidationError>(
 params?: ListAssetGroupsAssetGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetGroupsAssetGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssetGroupsAssetGroupsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Remove Asset Group
 */
export const removeAssetGroupAssetGroupsAssetGroupIdDelete = (
    assetGroupId: string,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<RemoveAssetGroupAssetGroupsAssetGroupIdDelete200>(
      {url: `/assetGroups/${assetGroupId}`, method: 'DELETE', signal
    },
      options);
    }



export const getRemoveAssetGroupAssetGroupsAssetGroupIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>, TError,{assetGroupId: string}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>, TError,{assetGroupId: string}, TContext> => {

const mutationKey = ['removeAssetGroupAssetGroupsAssetGroupIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>, {assetGroupId: string}> = (props) => {
          const {assetGroupId} = props ?? {};

          return  removeAssetGroupAssetGroupsAssetGroupIdDelete(assetGroupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAssetGroupAssetGroupsAssetGroupIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>>

    export type RemoveAssetGroupAssetGroupsAssetGroupIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Remove Asset Group
 */
export const useRemoveAssetGroupAssetGroupsAssetGroupIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>, TError,{assetGroupId: string}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAssetGroupAssetGroupsAssetGroupIdDelete>>,
        TError,
        {assetGroupId: string},
        TContext
      > => {
      return useMutation(getRemoveAssetGroupAssetGroupsAssetGroupIdDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary Get Pharos User Tos
 */
export const getPharosUserTosPharosUserTOSGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<GetPharosUserTosPharosUserTOSGet200>(
      {url: `/pharosUserTOS`, method: 'GET', signal
    },
      options);
    }




export const getGetPharosUserTosPharosUserTOSGetQueryKey = () => {
    return [
    `/pharosUserTOS`
    ] as const;
    }


export const getGetPharosUserTosPharosUserTOSGetQueryOptions = <TData = Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharosUserTosPharosUserTOSGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>> = ({ signal }) => getPharosUserTosPharosUserTOSGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharosUserTosPharosUserTOSGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>>
export type GetPharosUserTosPharosUserTOSGetQueryError = unknown


export function useGetPharosUserTosPharosUserTOSGet<TData = Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>,
          TError,
          Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharosUserTosPharosUserTOSGet<TData = Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>,
          TError,
          Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharosUserTosPharosUserTOSGet<TData = Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pharos User Tos
 */

export function useGetPharosUserTosPharosUserTOSGet<TData = Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharosUserTosPharosUserTOSGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharosUserTosPharosUserTOSGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Pharos User Tos Route
 */
export const updatePharosUserTosRoutePharosUserTOSPut = (
    updatePharosUserTOSRequest: UpdatePharosUserTOSRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdatePharosUserTosRoutePharosUserTOSPut200>(
      {url: `/pharosUserTOS`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePharosUserTOSRequest, signal
    },
      options);
    }



export const getUpdatePharosUserTosRoutePharosUserTOSPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>, TError,{data: UpdatePharosUserTOSRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>, TError,{data: UpdatePharosUserTOSRequest}, TContext> => {

const mutationKey = ['updatePharosUserTosRoutePharosUserTOSPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>, {data: UpdatePharosUserTOSRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePharosUserTosRoutePharosUserTOSPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePharosUserTosRoutePharosUserTOSPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>>
    export type UpdatePharosUserTosRoutePharosUserTOSPutMutationBody = UpdatePharosUserTOSRequest
    export type UpdatePharosUserTosRoutePharosUserTOSPutMutationError = HTTPValidationError

    /**
 * @summary Update Pharos User Tos Route
 */
export const useUpdatePharosUserTosRoutePharosUserTOSPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>, TError,{data: UpdatePharosUserTOSRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePharosUserTosRoutePharosUserTOSPut>>,
        TError,
        {data: UpdatePharosUserTOSRequest},
        TContext
      > => {
      return useMutation(getUpdatePharosUserTosRoutePharosUserTOSPutMutationOptions(options), queryClient);
    }

/**
 * @summary Update Pharos User Trial Route
 */
export const updatePharosUserTrialRoutePharosUserTrialPut = (
    updatePharosUserTrialRequest: UpdatePharosUserTrialRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdatePharosUserTrialRoutePharosUserTrialPut200>(
      {url: `/pharosUserTrial`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePharosUserTrialRequest, signal
    },
      options);
    }



export const getUpdatePharosUserTrialRoutePharosUserTrialPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>, TError,{data: UpdatePharosUserTrialRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>, TError,{data: UpdatePharosUserTrialRequest}, TContext> => {

const mutationKey = ['updatePharosUserTrialRoutePharosUserTrialPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>, {data: UpdatePharosUserTrialRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePharosUserTrialRoutePharosUserTrialPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePharosUserTrialRoutePharosUserTrialPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>>
    export type UpdatePharosUserTrialRoutePharosUserTrialPutMutationBody = UpdatePharosUserTrialRequest
    export type UpdatePharosUserTrialRoutePharosUserTrialPutMutationError = HTTPValidationError

    /**
 * @summary Update Pharos User Trial Route
 */
export const useUpdatePharosUserTrialRoutePharosUserTrialPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>, TError,{data: UpdatePharosUserTrialRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePharosUserTrialRoutePharosUserTrialPut>>,
        TError,
        {data: UpdatePharosUserTrialRequest},
        TContext
      > => {
      return useMutation(getUpdatePharosUserTrialRoutePharosUserTrialPutMutationOptions(options), queryClient);
    }

/**
 * @summary Update Pharos User Status Route
 */
export const updatePharosUserStatusRoutePharosUserStatusPut = (
    updatePharosUserStatusRequest: UpdatePharosUserStatusRequest,
 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<UpdatePharosUserStatusRoutePharosUserStatusPut200>(
      {url: `/pharosUserStatus`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePharosUserStatusRequest, signal
    },
      options);
    }



export const getUpdatePharosUserStatusRoutePharosUserStatusPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>, TError,{data: UpdatePharosUserStatusRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>, TError,{data: UpdatePharosUserStatusRequest}, TContext> => {

const mutationKey = ['updatePharosUserStatusRoutePharosUserStatusPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>, {data: UpdatePharosUserStatusRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePharosUserStatusRoutePharosUserStatusPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePharosUserStatusRoutePharosUserStatusPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>>
    export type UpdatePharosUserStatusRoutePharosUserStatusPutMutationBody = UpdatePharosUserStatusRequest
    export type UpdatePharosUserStatusRoutePharosUserStatusPutMutationError = HTTPValidationError

    /**
 * @summary Update Pharos User Status Route
 */
export const useUpdatePharosUserStatusRoutePharosUserStatusPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>, TError,{data: UpdatePharosUserStatusRequest}, TContext>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePharosUserStatusRoutePharosUserStatusPut>>,
        TError,
        {data: UpdatePharosUserStatusRequest},
        TContext
      > => {
      return useMutation(getUpdatePharosUserStatusRoutePharosUserStatusPutMutationOptions(options), queryClient);
    }

/**
 * @summary List Organizations Users Trials Route
 */
export const listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet = (

 options?: SecondParameter<typeof preferencesAxiosGenInstance>,signal?: AbortSignal
) => {


      return preferencesAxiosGenInstance<ListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet200>(
      {url: `/organizationsUsersTrials`, method: 'GET', signal
    },
      options);
    }




export const getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryKey = () => {
    return [
    `/organizationsUsersTrials`
    ] as const;
    }


export const getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>> = ({ signal }) => listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>>
export type ListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryError = unknown


export function useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet<TData = Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet<TData = Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet<TData = Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Organizations Users Trials Route
 */

export function useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet<TData = Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet>>, TError, TData>>, request?: SecondParameter<typeof preferencesAxiosGenInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
